// removed by extract-text-webpack-plugin
module.exports = {"root":"_32AkB","active":"_1qKX3","title":"_3oeNT","dot":"_3uamG","time":"_13LI1","smallMedia":"_yd0_b","imageWrapper":"_3Q0Kd","description":"_2KLDJ"};


//////////////////
// WEBPACK FOOTER
// ./app/components/ChannelBar/components/MediaCard/MediaCard.scss
// module id = 1123
// module chunks = 2